import React, { useEffect, useState } from 'react'
import article from './article.png'
import ArrowAnimation from './ArrowAnimation'
import logo from '../logo.png'

import ad1 from './ads/1.png'
import ad2 from './ads/2.png'
import ad3 from './ads/3.png'
import ad4 from './ads/4.png'
import useInterval from '../../../hooks/useInterval'
import { AnimatePresence, motion } from 'framer-motion'

const ReverseArrow = () => (
  <div className='transform rotate-180'>
    <ArrowAnimation />
  </div>
)
const UpArrow = () => (
  <div className='transform -rotate-90'>
    <ArrowAnimation />
  </div>
)

const variants = {
  active: {
    border: '1px solid rgba(255, 255, 255, 1)',
  },
  inactive: {
    border: '1px solid rgba(255, 255, 255, 0)',
    transition: { duration: 0.1 },
  },
}

const ProcessChart = () => {
  const [currentAd, setAd] = useState(1)
  const [random, setRandom] = useState(1)

  useInterval(() => setRandom(Math.floor(Math.random() * 4) + 1), 500)

  useInterval(() => setAd((prev) => (prev < 4 ? prev + 1 : 1)), 3000)

  useEffect(() => {
    console.log(random)
  }, [random])
  return (
    <div className='flex'>
      <div className='relative mr-10'>
        <div className='border'>
          <img src={article} alt='Sample Article' height={250} width={250} />
        </div>
        <div className='absolute flex' style={{ right: -45, top: 10 }}>
          <span className='px-2 pb-1 rounded-lg shadow-lg border bg-white font-semibold'>ptag.js</span>
          <ArrowAnimation />
        </div>
        <div className='absolute flex bottom-20 md:-bottom-1 -right-8'>
          <span className='px-2 pb-1 rounded-lg shadow-lg border bg-white font-semibold'>Ad content</span>
          <ReverseArrow />
        </div>
        <div className='absolute transform scale-75 md:scale-1 right-2 bottom-32 md:bottom-12' style={{}}>
          <img src={logo} alt='poplink' width={20} height={20} />
          <div className='shadow-xl relative' style={{ width: 150, height: 80, zIndex: 1 }}>
            <AnimatePresence>
              {currentAd === 1 && (
                <motion.img
                  initial={{ opacity: 0, left: -10 }}
                  animate={{ opacity: 1, left: 0 }}
                  exit={{ opacity: 0, left: 10 }}
                  src={ad1}
                  className='absolute w-full h-full'
                  alt='Ad1'
                />
              )}
            </AnimatePresence>

            <AnimatePresence>
              {currentAd === 2 && (
                <motion.img
                  initial={{ opacity: 0, left: -10 }}
                  animate={{ opacity: 1, left: 0 }}
                  exit={{ opacity: 0, left: 10 }}
                  src={ad2}
                  alt='Ad2'
                  className='absolute w-full h-full'
                />
              )}
            </AnimatePresence>

            <AnimatePresence>
              {currentAd === 3 && (
                <motion.img
                  initial={{ opacity: 0, left: -10 }}
                  animate={{ opacity: 1, left: 0 }}
                  exit={{ opacity: 0, left: 10 }}
                  src={ad3}
                  alt='Ad3'
                  className='absolute w-full h-full'
                />
              )}
            </AnimatePresence>

            <AnimatePresence>
              {currentAd === 4 && (
                <motion.img
                  initial={{ opacity: 0, left: -10 }}
                  animate={{ opacity: 1, left: 0 }}
                  exit={{ opacity: 0, left: 10 }}
                  src={ad4}
                  alt='Ad4'
                  className='absolute w-full h-full'
                />
              )}
            </AnimatePresence>
          </div>

          <div className='absolute right-0 -bottom-8'>
            <UpArrow />
          </div>
        </div>
      </div>
      <div
        className='p-4 bg-black text-white rounded-lg flex items-center justify-center'
        style={{ right: -220, top: 10 }}
      >
        <div>
          <div className='text-center mb-4 text-2xl font-light tracking-wide'>Poplink Ad Server</div>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4 p-2 sm:p-4 bg-black text-white rounded-lg font-light text-sm'>
            <motion.div
              className='text-center uppercase rounded p-1 sm:p-2'
              animate={random === 1 ? 'active' : 'inactive'}
              variants={variants}
              transition={{ duration: 0.2 }}
            >
              Opinions
            </motion.div>
            <motion.div
              className='text-center uppercase rounded p-1 sm:p-2'
              animate={random === 2 ? 'active' : 'inactive'}
              variants={variants}
            >
              Topics
            </motion.div>
            <motion.div
              className='text-center uppercase rounded p-1 sm:p-2'
              animate={random === 3 ? 'active' : 'inactive'}
              variants={variants}
            >
              Sentiment
            </motion.div>
            <motion.div
              className='text-center uppercase rounded p-1 sm:p-2'
              animate={random === 4 ? 'active' : 'inactive'}
              variants={variants}
            >
              Keywords
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProcessChart
